export default __webpack_public_path__ + "static/media/bb.459ddcf3.JPG";